import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

import './style.css';

function ContinueFooter(props) {
  const {
    disableContinue,
    continueLabel,
    onContinue,
    showBack,
    onBack,
    disableBack,
    backLabel,
    stacked,
    children
  } = props;

  return (
    <footer className={`ContinueFooter ${stacked && 'ContinueFooter--stacked'}`}>
      {showBack && (<FlatButton
        secondary
        label={backLabel}
        disabled={disableBack}
        onTouchTap={onBack}
      />)}
      {children}
      <RaisedButton
        primary={true}
        label={continueLabel}
        disabled={disableContinue}
        onTouchTap={onContinue}
        style={{ [stacked ? 'marginTop' : 'marginLeft']: 16 }}
      />
    </footer>
  );
}

ContinueFooter.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  continueLabel: PropTypes.string,
  disableContinue: PropTypes.bool,
  showBack: PropTypes.bool,
  disableBack: PropTypes.bool,
  stacked: PropTypes.bool,
};

ContinueFooter.defaultProps = {
  continueLabel: 'Continue',
  backLabel: 'Back',
  disableContinue: false,
  showBack: false,
  disableBack: false,
  stacked: false,
};

export default ContinueFooter;


// WEBPACK FOOTER //
// ./src/components/ContinueFooter/index.js